import React from "react";
import PublicLayout from "@/components/PublicLayout";

export default function Terms() {
  return (
    <PublicLayout>
      <main className="bg-sg-paper">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
          <div className="overline text-sg-gold-deep">LEGAL</div>
          <h1 className="font-display text-5xl text-sg-navy mt-1">Terms &amp; <span className="font-serif-italic text-sg-gold-deep">Conditions</span></h1>
          <p className="text-sg-mute mt-3 text-sm">
            Effective: 25 February 2026 · Last updated: 29 June 2026 · INPropPortal.com
          </p>

          <article className="mt-10 space-y-10 text-sg-navy leading-relaxed" data-testid="terms-article">
            <section>
              <h2 className="font-display text-2xl text-sg-navy">1. Acceptance of Terms</h2>
              <p className="mt-2 text-sg-mute">
                By accessing or using INPropPortal.com (the &ldquo;Service&rdquo;), you agree to be bound by these Terms &amp;
                Conditions and our Privacy Policy. If you do not agree, do not use the Service.
              </p>
            </section>

            <section data-testid="terms-data-ownership">
              <h2 className="font-display text-2xl text-sg-navy">2. Data Ownership and Accuracy Warranty</h2>
              <p className="mt-3 text-sg-navy">
                By submitting any content, including but not limited to property listings, floor plans, and project
                details (&ldquo;Content&rdquo;), the User represents and warrants that they are the owner of such
                Content or have obtained all necessary licenses, rights, and permissions to publish the Content. The
                User grants INPropPortal.com a non-exclusive, royalty-free, worldwide license to display and distribute
                the Content. The User acknowledges that they are solely responsible for ensuring that all Content
                provided complies with the Real Estate (Regulation and Development) Act (RERA) and all applicable laws.
                INPropPortal.com assumes no liability for inaccurate, unauthorized, or non-compliant Content provided
                by the User.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-sg-navy">3. MahaCRITI &amp; RERA Compliance</h2>
              <p className="mt-2 text-sg-mute">
                Every listing published on INPropPortal.com requires the agent to affirm — via an in-product checkbox —
                that they have explicit owner authorisation and that no unauthorised personal data is present. We log
                the agent ID and timestamp of every consent confirmation as an audit trail. Listings published without
                a confirmed consent record are subject to immediate take-down.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-sg-navy">4. Subscription &amp; Payments</h2>
              <p className="mt-2 text-sg-mute">
                Agent accounts on INPropPortal.com are subject to a recurring monthly subscription of ₹999 (GST
                inclusive), billed through Stripe. The Service may be cancelled at any time from the agent dashboard;
                cancellation takes effect at the end of the current billing cycle.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-sg-navy">5. Acceptable Use</h2>
              <p className="mt-2 text-sg-mute">
                You agree not to (a) impersonate any person or entity, (b) upload unauthorised personal data such as
                phone numbers, Aadhaar, PAN or unit numbers belonging to third parties, (c) post content that infringes
                any intellectual-property right, or (d) attempt to scrape, reverse-engineer, or circumvent the
                Service&apos;s security or rate limits.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-sg-navy">6. Limitation of Liability</h2>
              <p className="mt-2 text-sg-mute">
                To the maximum extent permitted by law, INPropPortal.com and its affiliates will not be liable for any
                indirect, incidental, special, consequential or punitive damages arising out of or related to your use
                of the Service. Our aggregate liability for any claims arising under these Terms is limited to the
                amounts you have paid to us in the three (3) months preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-sg-navy">7. Governing Law</h2>
              <p className="mt-2 text-sg-mute">
                These Terms are governed by the laws of India. Any dispute arising under or in connection with these
                Terms shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-sg-navy">8. Contact</h2>
              <p className="mt-2 text-sg-mute">
                Questions or take-down requests: <a className="text-sg-gold-deep border-b border-sg-gold" href="mailto:hello@inpropportal.com">hello@inpropportal.com</a>.
              </p>
            </section>
          </article>
        </div>
      </main>
    </PublicLayout>
  );
}
